import { useContext } from "react"
import { TenantContext } from "context/TenantContext"

/**
 * Hook to access and manage the current tenant context.
 *
 * @returns {{ tenantId: string|null, tenantName: string|null, tenantSettings: object, setTenant: Function, clearTenant: Function }}
 */
const useTenant = () => {
  const context = useContext(TenantContext)
  if (!context) {
    throw new Error("useTenant must be used within a TenantProvider")
  }
  return context
}

export default useTenant
